import { CategoryResponse } from '../types/api/CategoriesIndexTypes';

export const categoryBannerBackgroundDefaultStyles = 'linear-gradient( rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6) )';
export const categoryBannerBackgroundFallbackUrl = '/img/freevfx.png';

const generateBannerBackgroundImageFor = (category: CategoryResponse): string => {
  const url = category?.header_image || categoryBannerBackgroundFallbackUrl;
  return `${categoryBannerBackgroundDefaultStyles}, url(${url})`;
};

const uiHelpers = {
  generateBannerBackgroundImageFor,
};

export default uiHelpers;
